export default "__VITE_ASSET__BIo9jeNS__"